export const projectsData = [
  {
    id: 1,
    title: "AI Voice Interview Assistant",
    shortDescription:
      "An AI-powered voice agent that conducts mock interviews and provides real-time feedback to candidates.",
    fullDescription:
      "An intelligent interview preparation platform that uses a voice-based AI agent to simulate real interview scenarios. The system asks technical and behavioral questions, analyzes responses, and provides feedback to help users improve communication and confidence.",
    category: "Web App",
    thumbnail:
      "https://images.unsplash.com/photo-1589254065878-42c9da997008?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1589254065878-42c9da997008?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200&h=800&fit=crop",
    ],
    technologies: ["Next.js", "React", "Node.js", "Vapi AI", "Tailwind CSS"],
    liveUrl: "https://example.com",
    githubUrl: "https://github.com/theDivyansh/AI_Intetview_Assistant",
    featured: true,
    problem:
      "Many students lack real interview practice and confidence in verbal communication for technical roles.",
    role: "Full Stack Developer",
    process:
      "Built the frontend using Next.js and Tailwind, integrated Vapi AI for voice interactions, and developed backend logic for handling interview flows and response analysis.",
    results: [
      "Improved mock interview accessibility for students",
      "Real-time AI-driven feedback system",
      "Interactive voice-based interview simulation",
    ],
    duration: "3 months",
    year: "2025",
  },

  {
    id: 2,
    title: "Real-Time Chat Application",
    shortDescription:
      "A full-stack real-time chat application with authentication and live messaging.",
    fullDescription:
      "A modern chat platform that allows users to register, set avatars, and exchange real-time messages. Built with a clean UI and persistent chat storage, the app focuses on smooth user experience and scalable backend architecture.",
    category: "Web App",
    thumbnail:
      "https://images.unsplash.com/photo-1525182008055-f88b95ff7980?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1525182008055-f88b95ff7980?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=1200&h=800&fit=crop",
    ],
    technologies: ["React", "Node.js", "Express", "MongoDB", "Socket.IO"],
    liveUrl: "https://catty-chatty-8q7e.vercel.app/register",
    githubUrl: "https://github.com/theDivyansh/Catty_chatty",
    featured: true,
    problem:
      "Users needed a simple and responsive real-time communication platform with secure authentication.",
    role: "Full Stack Developer",
    process:
      "Developed REST APIs for authentication, implemented real-time messaging using Socket.IO, and designed a modern responsive UI with React and styled-components.",
    results: [
      "Real-time bidirectional communication",
      "Secure user authentication system",
      "Scalable backend architecture",
    ],
    duration: "2 months",
    year: "2025",
  },
  {
    id: 3,
    title: "ABHYUDAYA’25 — College Fest Management System",
    shortDescription:
      "A full-stack event management platform built to handle registrations, schedules, and coordination for a large-scale college fest.",
    fullDescription:
      "ABHYUDAYA’25 is a comprehensive web platform developed to manage the technical and cultural fest operations at MMMUT. The system streamlined event registrations, participant management, and coordination between organizers, enabling a smooth and scalable digital workflow for the fest.",
    category: "Group Project",
    thumbnail:
      "https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1511578314322-379afb476865?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1503424886307-b090341d25d1?w=1200&h=800&fit=crop",
    ],
    technologies: ["Node.js", "Express", "MongoDB", "React", "REST APIs"],
    liveUrl: "https://abhyudaya.live/",
    githubUrl: "https://github.com/theDivyansh/Abhyudaya-25",
    featured: true,
    problem:
      "Managing registrations, schedules, and participant data manually for a large college fest led to inefficiencies, data errors, and coordination challenges among organizing teams.",
    role: "Backend Developer",
    process:
      "Designed and developed RESTful APIs for event registration, user authentication, and data management. Structured MongoDB schemas for participants, events, and coordinators. Worked closely with the frontend team to ensure seamless integration and smooth user flows.",
    results: [
      "Streamlined fest registration and management process",
      "Reduced manual coordination efforts for organizers",
      "Improved data accuracy and accessibility",
      "Handled high concurrent traffic during peak registration periods",
    ],
    duration: "3 months",
    year: "2025",
  },
  {
    id: 4,
    title: "Deep Learning for Brain Stroke Classification",
    shortDescription:
      "A deep learning system for detecting brain stroke from medical imaging under adversarial threats.",
    fullDescription:
      "A research-focused deep learning project that classifies brain stroke images while analyzing robustness against adversarial attacks. The system emphasizes medical AI reliability and model security.",
    category: "Group Project",
    thumbnail:
      "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1617791160505-6f00504e3519?w=1200&h=800&fit=crop",
    ],
    technologies: ["Python", "TensorFlow", "Deep Learning", "Adversarial ML"],
    liveUrl: "https://example.com",
    githubUrl: "https://github.com/theDivyansh/NeuroAI",
    featured: false,
    problem:
      "Medical AI systems are vulnerable to adversarial attacks, which can lead to incorrect diagnoses.",
    role: "ML Developer & Researcher",
    process:
      "Collected medical imaging data, trained CNN-based models, and evaluated robustness using adversarial attack techniques.",
    results: [
      "Improved model robustness against adversarial noise",
      "Accurate stroke classification model",
      "Research presentation for final year project",
    ],
    duration: "6 months",
    year: "2025",
  },
  {
    id: 5,
    title: "Workout Tracker API",
    shortDescription:
      "A comprehensive backend REST API for managing workouts, exercises, user authentication, and performance tracking.",
    fullDescription:
      "A fully featured Workout Tracker API designed to support fitness applications. Built using Node.js and Express with MongoDB, this API empowers clients to securely authenticate users, log and manage workouts, categorize exercises, and generate detailed progress reports. It includes Swagger/OpenAPI documentation and comprehensive testing to ensure robustness and reliability.",
    category: "Backend API",
    thumbnail:
      "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1526401485004-9df8e4d9e1b8?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1587502536263-3c9e627f15d7?w=1200&h=800&fit=crop",
    ],
    technologies: ["Node.js", "Express", "MongoDB", "JWT", "Swagger"],
    liveUrl: "https://example.com",
    githubUrl: "https://github.com/theDivyansh/Workout_Tracker",
    featured: false,
    problem:
      "Fitness and workout applications often require a robust backend to handle user authentication, structured workout logging, exercise categorization, and historical analysis — this API fills that gap with secure and scalable endpoints.",
    role: "Backend Developer",
    process:
      "Designed RESTful routes for users, workouts, and exercise data. Implemented JWT-based authentication with secure password hashing. Structured MongoDB schemas for workouts, users, and exercise history. Added Swagger documentation for easy API exploration. Wrote unit and integration tests to validate endpoint reliability.",
    results: [
      "Secure user authentication with JWT tokens",
      "Fully documented REST API with Swagger/OpenAPI",
      "CRUD operations for workouts and exercises",
      "Performance tracking and report endpoints",
      "Comprehensive test coverage ensuring API reliability",
    ],
    duration: "1 month",
    year: "2026",
  },
];
